import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFathom = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 1000 143",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#007299",
				d: "M857.29,95.62v29.43c0,7.72,4.89,14.71,12.24,17.03,12.49,3.93,23.96-5.29,23.96-17.19v-11.08l-36.2-18.19Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#00beff",
				d: "M981.98,89.53c-2.72,0-5.48-.61-8.08-1.91l-106.23-53.09c-8.8-4.4-12.89-14.99-8.79-23.93,4.28-9.36,15.42-13.24,24.55-8.68l106.21,53.08c8.91,4.45,12.99,15.6,8.53,24.51-3.17,6.35-9.56,10.02-16.21,10.02Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#00beff",
				d: "M928.66,116.35c-2.72,0-5.48-.61-8.08-1.91l-52.91-26.44c-8.8-4.4-12.89-14.99-8.79-23.93,4.28-9.36,15.42-13.24,24.56-8.68l52.89,26.43c8.91,4.45,12.99,15.6,8.53,24.51-3.17,6.35-9.56,10.02-16.21,10.02Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#faf5f5",
				d: "M21.84,141.01H0V1.99h97.27v20.85H21.84v39.72h59.55v20.85H21.84v57.6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#faf5f5",
				d: "M276.63,141.01h-21.84V21.85h-41.69V1.99h105.21v19.86h-41.69v119.17Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#faf5f5",
				d: "M358.69,141.01h-21.84V1.99h21.84v58.59h68.49V1.99h21.84v139.03h-21.84v-60.58h-68.49v60.58Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#faf5f5",
				d: "M507.18,133.47c-11.25-6.36-20.08-15-26.5-25.92-6.42-10.92-9.63-22.94-9.63-36.05s3.21-25.12,9.63-36.05c6.42-10.92,15.25-19.56,26.5-25.92C518.43,3.18,530.87,0,544.5,0s26.07,3.18,37.32,9.53c11.25,6.36,20.08,15,26.5,25.92,6.42,10.92,9.63,22.94,9.63,36.05s-3.21,25.13-9.63,36.05c-6.42,10.92-15.25,19.56-26.5,25.92-11.25,6.35-23.69,9.53-37.32,9.53s-26.07-3.18-37.32-9.53ZM570.51,116.29c7.94-4.57,14.19-10.82,18.76-18.77,4.57-7.94,6.85-16.62,6.85-26.02s-2.28-18.07-6.85-26.02c-4.57-7.95-10.82-14.2-18.76-18.77-7.94-4.57-16.61-6.85-26.01-6.85s-18.06,2.28-26.01,6.85c-7.94,4.57-14.19,10.82-18.76,18.77-4.57,7.94-6.85,16.62-6.85,26.02s2.28,18.07,6.85,26.02c4.57,7.95,10.82,14.2,18.76,18.77,7.94,4.57,16.61,6.85,26.01,6.85s18.06-2.28,26.01-6.85Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#faf5f5",
				d: "M661.82,141.01h-21.84V1.99h20.05l52.41,67.33h.4L765.25,1.99h19.65v139.03h-21.84V39.32h-.79l-49.83,63.95-49.83-63.95h-.79v101.69Z"
			})
		] }), /* @__PURE__ */ _jsx("path", {
			fill: "#faf5f5",
			d: "M224.97,141.01L169.39,1.99h-23.82l-55.58,139.03h22.43l44.47-113.8h.4l26.89,68.83c-10.67-7.54-22.15-13.93-34.2-18.94l-8.18,19.71c23.11,9.6,43.84,24.88,59.96,44.19h0s23.23,0,23.23,0Z"
		})] })
	]
});
const ForwardRef = forwardRef(SvgFathom);
export { ForwardRef as ReactComponent };
